import React, { useEffect } from 'react';
import { ProductActivation } from '@dtp/membership-service-types';
import { ActivationProductField } from './ActivationProductField';
import { AddonProductFieldProps } from './AddonProductField.types';
import { HouseholdPaymentProductField } from './HouseholdPaymentProductField';
import { IndividualPaymentProductField } from './IndividualPaymentProductField';

export const AddonProductField = ({
  product,
  members,
  storedMembers,
  control,
  errors,
  watch,
  setValue,
  getValues,
  unregister,
  tracking,
}: AddonProductFieldProps) => {
  const productValues = watch(product.productNumber);
  const selectedMembers = (productValues as { members?: string[] } | undefined)?.members;
  const selectedMemberCount = selectedMembers?.length;

  useEffect(() => {
    const subscription = watch((values) => {
      const watchedProduct = values[product.productNumber] as { members?: string[] } | undefined;
      if (watchedProduct?.members?.length === 0 && Object.values(watchedProduct).length > 1) {
        Object.values(product.fieldComponents).forEach((field) => {
          unregister(`${product.productNumber}.props.${field.id}`);
        });
      }
    });
    return () => subscription.unsubscribe();
  }, [product, unregister, watch]);

  useEffect(() => {
    const storedProduct = getValues(product.productNumber) as { members?: string[] } | undefined;
    if (
      product.productActivationType === ProductActivation.ActivationProduct &&
      product.isRequiredAddOn &&
      (storedProduct?.members?.length ?? 0) === 0
    ) {
      setValue(product.productNumber, { members: ['0'] });
    }
  }, [getValues, product, selectedMemberCount, setValue]);

  if (!product.isHouseholdProduct && product.productActivationType === ProductActivation.PaymentProduct) {
    return (
      <IndividualPaymentProductField
        product={product}
        selectedMembers={selectedMembers}
        storedMembers={storedMembers}
        control={control}
        errors={errors}
        watch={watch}
        setValue={setValue}
        members={members}
        tracking={tracking}
      />
    );
  }

  if (product.isHouseholdProduct && product.productActivationType === ProductActivation.PaymentProduct) {
    return (
      <HouseholdPaymentProductField
        product={product}
        selectedMembers={selectedMembers}
        storedMembers={storedMembers}
        control={control}
        errors={errors}
        watch={watch}
        setValue={setValue}
        members={members}
      />
    );
  }

  if (product.productActivationType === ProductActivation.ActivationProduct) {
    return (
      <ActivationProductField
        product={product}
        selectedMembers={selectedMembers}
        storedMembers={storedMembers}
        control={control}
        errors={errors}
        watch={watch}
        setValue={setValue}
      />
    );
  }

  return null;
};
